import { useState } from 'react';
import AddForm from './AddForm';
import FilterForm from './FilterForm';
import getMonthList from './monthList';
import getMonth from './setMonth';
import { toast } from 'react-toastify';

const Ops = ({ fetchTransactions, showInfoMonth, showInfoCreatedBy }) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const toggleAddForm = () => setShowAddForm(!showAddForm);

  const [showFilterForm, setShowFilterForm] = useState(false);
  const toggleFilterForm = () => setShowFilterForm(!showFilterForm);

  const [monthList, setMonthList] = useState(null);
  const getMonthObj = async () => {
    const { trackerId } = JSON.parse(localStorage.getItem('user'));
    try {
      const res = await fetch(
        `https://api.dcsoft.ro/ext/api/transactions/filters/months/${trackerId}`
      );
      if (!res.ok)
        throw new Error(
          `Error fetching months: ${res.status} - ${res.statusText}`
        );
      const data = await res.json();
      if (data.length) {
        setMonthList(getMonthList(data));
      } else {
        const optionValues = [getMonth()];
        const optionTexts = [
          new Date(optionValues[0]).toLocaleString('ro-RO', {
            month: 'long',
            year: 'numeric',
          }),
        ];
        setMonthList({
          optionTexts,
          optionValues,
        });
      }
    } catch (error) {
      toast.error('Eroare date luni!');
      console.log(error.message);
    }
  };

  const [memberList, setMemberList] = useState([]);
  const getMemberList = async () => {
    const { trackerId } = JSON.parse(localStorage.getItem('user'));
    try {
      const res = await fetch(
        `https://api.dcsoft.ro/ext/api/users/members/${trackerId}`
      );
      if (!res.ok)
        throw new Error(
          `Error fetching members: ${res.status} - ${res.statusText}`
        );
      const data = await res.json();
      setMemberList(data.members);
    } catch (error) {
      toast.error('Eroare date membri!');
      console.log(error.message);
    }
  };

  return (
    <>
      <div className="btn-bar">
        <button
          className="btn filter-form-btn"
          onClick={() => {
            getMonthObj();
            getMemberList();
            toggleFilterForm();
            if (!showFilterForm) setShowAddForm(false);
          }}
        >
          Filtreaza
        </button>
        <button
          className="btn add-form-btn"
          onClick={() => {
            toggleAddForm();
            if (!showAddForm) setShowFilterForm(false);
          }}
        >
          Adauga
        </button>
      </div>
      <AddForm
        show={showAddForm}
        toggle={toggleAddForm}
        fetchTransactions={fetchTransactions}
        showInfoMonth={showInfoMonth}
        showInfoCreatedBy={showInfoCreatedBy}
      />
      {monthList && (
        <FilterForm
          show={showFilterForm}
          toggle={toggleFilterForm}
          months={monthList}
          members={memberList}
          fetchTransactions={fetchTransactions}
          showInfoMonth={showInfoMonth}
          showInfoCreatedBy={showInfoCreatedBy}
        />
      )}
    </>
  );
};

export default Ops;
